/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { getInternalCookie, COOKIE, deleteCookie, getCookie, setCookie } from 'apmui/common/Cookie';
import { hex_md5 } from 'apmui/util/md5';

const FAVORITES_COOKIE_NAME = 'F5_VDI_' + getInternalCookie(COOKIE.LASTMRH_SESSION);

function getFavoriteIndex(favorite: string) {
    return hex_md5(favorite).substr(0, 7);
}

function getVisitedFavorites(): string[] {
    const favoritesStr = getCookie(FAVORITES_COOKIE_NAME);
    return favoritesStr ? favoritesStr.split(',') : [];
}

function markFavoriteAsVisited(favorite: string) {
    const visitedFavorites = getVisitedFavorites();
    const index = getFavoriteIndex(favorite);

    if (visitedFavorites.indexOf(index) === -1) {
        visitedFavorites.push(index);
        setCookie(FAVORITES_COOKIE_NAME, visitedFavorites.join(','));
    }
}

function clearVisitedFavorites() {
    deleteCookie(FAVORITES_COOKIE_NAME);
}

function isFavoriteVisited(favorite: string) {
    return getVisitedFavorites().indexOf(getFavoriteIndex(favorite)) >= 0;
}

export { isFavoriteVisited, clearVisitedFavorites, markFavoriteAsVisited };
